<template>
    <div class="order-container">
        <div class="left-side" :class="collapseBranches ? 'collapsed' : ''">
            <div class="wrap-left">
                <div class="__kfc_search_order">
                    <div class="header-hero __kfc_flex __kfc_flex_column">
                        <div class="__kfc_r_2 header">
                            <span>
                                {{ $t('trackOrder') }}
                            </span>
                            <svg v-if="!collapseBranches" @click="toggleSvg" class="collapseSvg"
                                xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
                                <path
                                    d="M3.50298 17.0072C3.38657 16.8911 3.29421 16.7532 3.2312 16.6013C3.16818 16.4494 3.13574 16.2866 3.13574 16.1222C3.13574 15.9578 3.16818 15.795 3.2312 15.6431C3.29421 15.4913 3.38657 15.3533 3.50298 15.2372L11.813 6.92721C11.9055 6.83451 12.0154 6.76096 12.1364 6.71078C12.2573 6.6606 12.387 6.63477 12.518 6.63477C12.6489 6.63477 12.7786 6.6606 12.8996 6.71078C13.0206 6.76096 13.1305 6.83451 13.223 6.92721L21.533 15.2372C22.023 15.7272 22.023 16.5172 21.533 17.0072C21.043 17.4972 20.253 17.4972 19.763 17.0072L12.513 9.76721L5.26298 17.0172C4.78298 17.4972 3.98298 17.4972 3.50298 17.0072Z"
                                    fill="black" />
                            </svg>
                            <svg v-else @click="toggleSvg" class="collapseSvg" xmlns="http://www.w3.org/2000/svg" width="25"
                                height="24" viewBox="0 0 25 24">
                                <path
                                    d="M3.59673 7.00353C3.48032 7.11965 3.38796 7.25759 3.32495 7.40945C3.26193 7.56131 3.22949 7.72412 3.22949 7.88853C3.22949 8.05295 3.26193 8.21575 3.32495 8.36762C3.38796 8.51948 3.48032 8.65742 3.59673 8.77353L11.9067 17.0835C11.9992 17.1762 12.1091 17.2498 12.2301 17.3C12.3511 17.3501 12.4808 17.376 12.6117 17.376C12.7427 17.376 12.8724 17.3501 12.9934 17.3C13.1143 17.2498 13.2242 17.1762 13.3167 17.0835L21.6267 8.77353C22.1167 8.28353 22.1167 7.49353 21.6267 7.00353C21.1367 6.51353 20.3467 6.51353 19.8567 7.00353L12.6067 14.2435L5.35673 6.99353C4.87673 6.51353 4.07673 6.51353 3.59673 7.00353Z"
                                    fill="black" />
                            </svg>
                        </div>
                        <el-input v-model="orderNumber" :placeholder="$t('trackOrder')" class="order-input __kfc_r_7"
                            @keyup.enter="handleSearch">
                            <template #prepend>
                                <img src="@/assets/icons/orderCar.png" alt="" />
                            </template>
                            <template #append>
                                <el-button :icon="Search" @click="handleSearch" />
                            </template>
                        </el-input>
                    </div>
                    <div class="step-hero __kfc_flex __kfc_flex_column">
                        <span class="__kfc_r_4" v-if="orderType === 1">{{ $t('delivery') }}</span>
                        <span class="__kfc_r_4" v-if="orderType === 2">{{ $t('pickup') }} </span>
                        <div class="steps">
                            <div class="wrap-steps __kfc_flex __kfc_flex_column">
                                <span class="__kfc_r_5">{{ $t('orderProcess') }}</span>
                                <div class="__order_pi_step">
                                    <el-steps :space="50" :active="statusStep" finish-status="success" direction="vertical"
                                        align-center>
                                        <el-step class="__kfc_r_8" title="Захиалга авсан" />
                                        <el-step class="__kfc_r_8" title="Бэлтгэж дууссан" />
                                        <el-step class="__kfc_r_8" title="Захиалга гарсан" />
                                        <!-- <el class="__kfc_r_8"-step title="Захиалга хүрсэн" /> -->
                                        <el-step class="__kfc_r_8" title="Захиалга дууссан" />
                                    </el-steps>
                                </div>
                            </div>
                        </div>
                        <div class="order-description">
                            <div class="wrap-description __kfc_flex __kfc_flex_column">
                                <span class="__kfc_r_5">
                                    {{ $t('moreInformation') }}
                                </span>
                                <div class="__kfc_flex __kfc_flex_column parent">
                                    <div class="__kfc_flex item">
                                        <span class="__kfc_r_9">
                                            {{ $t('orderNumber') }}:
                                        </span>
                                        <span class="__kfc_r_8">
                                            {{ orderNumber }}
                                        </span>
                                    </div>
                                    <div class="__kfc_flex item">
                                        <span v-if="orderType === 1" class="__kfc_r_9">
                                            {{ $t('deliveryBranch') }}:
                                        </span>
                                        <span v-if="orderType === 2" class="__kfc_r_9">
                                            {{ $t('selectPickupAddress') }}:
                                        </span>
                                        <span class="__kfc_r_8">
                                            {{ orderOutlet?.outletname }}
                                        </span>
                                    </div>
                                    <div class="__kfc_flex item">
                                        <span v-if="orderType === 2" class="__kfc_r_9">
                                            {{ $t('pickupTime') }}:
                                        </span>
                                        <span v-if="orderType === 2" class="__kfc_r_8">
                                            {{ promised_time }}
                                        </span>
                                    </div>
                                    <div class="__kfc_flex item">
                                        <span class="__kfc_r_9">
                                            {{ $t('phoneNo') }}:
                                        </span>
                                        <span class="__kfc_r_8">
                                            {{ outletPhone }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-hero __kfc_flex __kfc_flex_column">
                        <span class="__kfc_r_7">
                            {{ $t('product') }}
                        </span>
                        <div class="products-container">
                            <div class="wrap-products __kfc_flex __kfc_flex_column">
                                <div class="product __kfc_flex" v-for="(product, index) in computedFoodDetails"
                                    :key="index">
                                    <div class="image"></div>
                                    <div class="description __kfc_flex __kfc_flex_column">
                                        <span class="__kfc_r_6 parent-item-name">
                                            {{ locale === 'mn' ? product.name_mon : product.name_eng }}
                                            ({{ product.item_count }})
                                        </span>
                                        <div class="__kfc_flex __kfc_flex_column child-items">
                                            <div class="__kfc_flex child" v-for="(item, ind) in product.childItems"
                                                :key="ind">
                                                <span class="__kfc_r_8 count">
                                                    {{ item.item_count }}ш
                                                </span>
                                                <span class="__kfc_r_9">
                                                    {{ locale === 'mn' ? item.name_mon : item.name_eng }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="product __kfc_r_8 __kfc_flex">
                                    <div class="image"></div>
                                    <div class="__kfc_flex total-price">
                                        <span>Нийт</span>
                                        <span class="__kfc_color_red">{{ $formatCurrency(menuTotal) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-side">
            <GMapMap class="map" :center="center" :zoom="zoom" :options="options" :draggable="false" :key="orderOutlet">
                <GMapMarker v-if="orderPlace" :key="orderPlace"
                    :position="{ lat: parseFloat(orderPlace.latitude), lng: parseFloat(orderPlace.longitude) }"
                    :icon="markerCurrentPos" @mouseover="openedPlace = true" @mouseout="openedPlace = false"
                    title="">
                    <GMapInfoWindow :closeclick="true" @closeclick="() => { markerCloseClick('place') }"
                        :opened="openedPlace">

                        <div class="__marker_pin_delivery_target">
                            <div class="__kfc_r_8 __marker_desc">
                                <p>{{ orderPlace.addr_bair }}</p>
                                <p>{{ orderPlace.addr_tailbar }}</p>
                            </div>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>
                <GMapMarker v-if="carPosition.active" :key="carPosition"
                    :position="{ lat: parseFloat(carPosition.lat), lng: parseFloat(carPosition.lng) }" :icon="markerCar"
                    title="">
                </GMapMarker>
                <GMapMarker v-if="orderOutlet" :key="orderOutlet"
                    :position="{ lat: parseFloat(orderOutlet.latitude), lng: parseFloat(orderOutlet.longitude) }"
                    :icon="markerImg" @click="markerClick('outlet', orderOutlet.latitude, orderOutlet.longitude)" title="">
                    <GMapInfoWindow :closeclick="true" @closeclick="() => { markerCloseClick('outlet') }"
                        :opened="openedOutlet">

                        <div class="__marker_pin">
                            <div class="__marker_img">
                                <img :src="cdn + orderOutlet.img_url" alt="KFC mongolia" />
                            </div>
                            <div class="__kfc_r_8 __marker_desc">
                                <span v-if="locale == 'mn'">{{ orderOutlet.name_mn }}</span>
                                <span v-else>{{ orderOutlet.name_en }}</span>
                            </div>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>
            </GMapMap>
        </div>
    </div>
</template>
  
<script >
import configJson from '../../config'
import Req from '@/utils/Request';
import { computed, inject, reactive, ref } from 'vue';
import markerCar from '@/assets/images/markerCar.png'
import markerCurrentPos from '@/assets/icons/ph_map-pin-fill.svg'
import { useStore } from 'vuex';
import { useRoute } from 'vue-router'
import { Search } from '@element-plus/icons-vue'
import markerImg from '@/assets/icons/marker.svg'
import { useGtm } from '@gtm-support/vue-gtm';
import axios from 'axios';

export default {
    setup () {
        const store = useStore();
        const route = useRoute()
        const gtm = useGtm();
        const notify = inject('notify');
        const locale = computed(() => store.getters.locale);
        const collapseBranches = ref(false);
        const zoom = ref(13);
        const cdn = configJson.CLOUDFRONT_IMAGE_PATH;
        const center = reactive({ lat: 47.88830914483325, lng: 106.89362007284807 });
        const options = reactive({
            scrollwheel: true,
            streetViewControl: false,
            disableDefaultUI: false,
            mapTypeControl: false,
            minZoom: 10,
            maxZoom: 20,
            gestureHandling: 'greedy'// 'cooperative'//greedy
        });
        const orderNumber = ref(route.query.u ?? null);
        const menuTotal = ref(0);
        const orderOutlet = ref(null);
        const orderPlace = ref(null);
        const orderType = ref(1);
        const promised_time = ref('');
        const openedOutlet = ref(false);
        const openedPlace = ref(false);
        const outletPhone = ref('');
        const carPosition = reactive({
            lat: 0,
            lng: 0,
            active: false
        });
        const markerClick = (type, lat, lng) => {
            if (type === 'outlet') {
                openedOutlet.value = true;
            } else if (type === 'place') {
                openedPlace.value = true;
            }
            center.lat = parseFloat(lat);
            center.lng = parseFloat(lng)
        }
        const markerCloseClick = (type) => {
            if (type === 'outlet') {
                openedOutlet.value = false;
            } else if (type === 'place') {
                openedPlace.value = false;
            }
        }
        const statusStep = ref(null);
        const food_details = ref(null);
        const toggleSvg = () => {
            collapseBranches.value = !collapseBranches.value;
        }
        const handleSearch = async () => {
            gtm.trackEvent({
                event: 'search_order_process',
            });
            const { data: orderResult } = await Req({ url: '/order/getOrderDetailForTracking', body: { order_number: orderNumber.value }, hideSuccess: true })
            if (orderResult.success) {
                menuTotal.value = orderResult.result.pay_total
                orderPlace.value = orderResult.result;
                food_details.value = orderResult.result.food_details;
                orderType.value = parseInt(orderResult.result.order_type)
                promised_time.value = orderResult.result.promised_time
                setStatusStep(orderResult.result);
                getOutlet(orderResult.result.outlet_name);
                getDriverLocation(orderResult.result.order_uuid)
                if (orderType.value === 1) {
                    openedPlace.value = false
                }
            } else {
                // orderOutlet.value = ''
                // statusStep.value = 0
                // menuTotal.value = 0
                // carPosition.active = false
            }
        }
        const computedFoodDetails = computed(() => {
            const parentItems = food_details.value?.filter(item => item.parent_index === 0);
            parentItems?.forEach(element => {
                const childItems = food_details.value?.filter(item => item.parent_index === element.item_index);
                element.childItems = childItems
            });
            return parentItems;
        });
        const getOutlet = async (outlet_name) => {
            const { data: outletResult } = await Req({ url: '/manager/getOutletByOutletName', body: { outlet_name }, hideSuccess: true });
            if (outletResult.success) {
                orderOutlet.value = outletResult.result;
                center.lat = parseFloat(outletResult.result.latitude);
                center.lng = parseFloat(outletResult.result.longitude)
                openedOutlet.value = true;
                outletPhone.value = outletResult.result.phone;

            }
        }
        const getDriverLocation = async (uuid) => {
            const { data: driverResult } = await Req({ url: '/manager/getDriverStatus', body: { order_uuid: uuid }, hideSuccess: true })
            if (driverResult.success) {
                carPosition.lat = parseFloat(driverResult?.result?.latitude);
                carPosition.lng = parseFloat(driverResult?.result?.longitude);
                carPosition.active = true;
                center.lat = parseFloat(driverResult?.result?.latitude);
                center.lng = parseFloat(driverResult?.result?.longitude);

            }
        }
        const setStatusStep = (data) => {
            switch (data.order_status) {
                case 10:
                    statusStep.value = 1
                    data.order_status_text = 'Хадгалсан'
                    break
                case 11:
                    statusStep.value = 1
                    data.order_status_text = 'CC Баталгаажуулсан'
                    break
                case 14:
                    statusStep.value = 1
                    data.order_status_text = 'Веб урьдчилсан захиалга'
                    break
                case 15:
                    statusStep.value = 1
                    data.order_status_text = 'Веб төлбөр шалгах'
                    break
                case 18:
                    statusStep.value = 1
                    data.order_status_text = 'Ирж авах захиалга'
                    break
                case 19:
                    statusStep.value = 1
                    data.order_status_text = 'Урьдчилсан захиалга'
                    break
                case 20:
                    statusStep.value = 1
                    data.order_status_text = 'Баталгаажсан'
                    break
                case 30:
                    statusStep.value = 2
                    data.order_status_text = 'Гал тогоо хүлээн авсан'
                    break
                case 31:
                    statusStep.value = 2
                    data.order_status_text = 'Бэлэн болсон'
                    break
                case 50:
                    statusStep.value = 3
                    data.order_status_text = 'Хүргэлтэнд гарсан'
                    break
                case 51:
                    statusStep.value = 4
                    data.order_status_text = 'Очсон'
                    break
                case 52:
                    statusStep.value = 3
                    data.order_status_text = 'Жолоочид хувиарласан'
                    break
                case 53:
                    statusStep.value = 3
                    data.order_status_text = 'Салбарлуу'
                    break
                case 91:
                    statusStep.value = 0
                    data.order_status_text = 'Цуцалсан'
                    break
                case 90:
                    statusStep.value = 0
                    data.order_status_text = 'Цуцласан CC'
                    break
                case 92:
                    statusStep.value = 0
                    data.order_status_text = 'Татгалзсан'
                    break
                case 93:
                    statusStep.value = 0
                    data.order_status_text = 'Цуцлах хүсэлт'
                    break
                case 100:
                    statusStep.value = 5
                    data.order_status_text = 'Амжилттай хүргэгдсэн'
                    break
                default:
                    statusStep.value = 0
                    break
            }
        }
        if (orderNumber.value) {
            handleSearch();
        }
        gtm.trackEvent({
            event: 'click_order_process',
        });
        return {
            outletPhone, orderPlace, openedPlace, openedOutlet, promised_time, collapseBranches, markerCar, markerImg, markerCurrentPos, computedFoodDetails, menuTotal, orderType, locale, statusStep, orderNumber, orderOutlet, carPosition, orderNumber, center, zoom, cdn, options, food_details, Search, handleSearch, toggleSvg, markerClick, markerCloseClick
        }
    },
}
</script>
<style scoped lang="scss">
.order-container {
    display: flex;
    height: calc(100vh - 106px);
    position: relative;

    .__marker_pin_delivery_target {
        background: $redMain;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        // @media (max-width: 900px) {
        //     display: block;
        //     height: calc(100vh - 54px);
        // }
        align-items: center;

        .__marker_img {
            height: 200px;
            width: 200px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .__marker_desc {
            text-align: center;

            span,
            p {
                width:200px;
                color: $whiteMain;
                overflow:auto;
            }
        }
    }
    .__marker_pin {
        background: $redMain;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;

        // @media (max-width: 900px) {
        //     display: block;
        //     height: calc(100vh - 54px);
        // }

        .__marker_img {
            height: 200px;
            width: 200px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .__marker_desc {
            text-align: center;

            span,
            p {
                width:200px;
                color: $whiteMain;
                overflow:auto;
            }
        }
    }

    .left-side {
        &.collapsed {
            height: 90%;
        }

        width: 30%;
        height: 100%;
        transition: ease-out 0.3s;

        @media (max-width: 900px) {
            width: 100%;
            position: absolute;
            height: 40%;
            bottom: 0;
            z-index: 1;
            background: #fff;
        }

        .wrap-left {
            padding: 40px;
            height: 100%;
            overflow-y: auto;

            @media (max-width: 900px) {
                padding: 20px;
            }

            .__kfc_search_order {
                display: flex;
                flex-direction: column;
                gap: 20px;

                .header-hero {
                    gap: 16px;

                    .order-input {
                        img {
                            width: 24px;
                        }

                    }

                    .header {
                        color: $redMain;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .collapseSvg {
                            cursor: pointer;
                            display: none;

                            @media (max-width: 900px) {
                                display: block;
                            }
                        }
                    }
                }

                .step-hero {
                    gap: 16px;

                    .steps {
                        background: $dark3;
                        border-radius: 4px;

                        .wrap-steps {
                            padding: 20px 16px;
                            gap: 16px;
                        }
                    }

                    .order-description {
                        background: $dark3;
                        border-radius: 4px;

                        .wrap-description {
                            padding: 20px 16px;
                            gap: 16px;

                            .parent {
                                gap: 8px;

                                .item {
                                    gap: 12px;

                                    .__kfc_r_9 {
                                        color: $dark80;
                                    }
                                }
                            }

                        }
                    }
                }

                .product-hero {
                    gap: 16px;

                    .products-container {
                        background: $dark3;
                        border-radius: 4px;

                        .wrap-products {
                            padding: 16px;
                            gap: 8px;

                            .product {
                                gap: 24px;

                                .image {
                                    width: 25%;

                                    img {
                                        width: 100%;
                                    }
                                }

                                .total-price {
                                    width: 75%;
                                    justify-content: space-between;
                                }

                                .description {
                                    width: 75%;
                                    gap: 8px;

                                    .parent-item-name {
                                        color: $redMain;
                                    }

                                    .child-items {
                                        gap: 4px;

                                        .child {
                                            gap: 8px;

                                            .count {
                                                flex-basis: 35px;
                                            }
                                        }
                                    }
                                }
                            }

                            .total-price {
                                width: 75%;
                                align-self: flex-end;
                            }
                        }
                    }
                }
            }

        }
    }

    .right-side {
        width: 70%;

        @media (max-width: 900px) {
            width: 100%;
            height: 70%;
        }

        .map {
            width: 100%;
            height: 100%;
        }
    }
}
</style>>